export default "__VITE_ASSET__CRW5AV4v__"